module.exports = __webpack_public_path__ + "static/feature-switch-a0cca306bd28d214dd7255976860182d.png";